import type { Theme } from './types.js'

/** Slate Pro — Corporate blue. Outil de conformité sérieux, adjacent EU/réglementaire. */
export const slatePro: Theme = {
  id: 'slate-pro',
  displayName: 'Slate Pro',
  description: 'Bleu corporate, sobre et professionnel',
  preview: { primary: '#2563eb', sidebar: '#0c1022', accent: '#d97706' },
  tokens: {
    colors: {
      primary: '#2563eb',
      primaryHover: '#1d4ed8',
      primaryLight: '#eff6ff',
      secondary: '#0f766e',
      accent: '#d97706',
      surface: '#ffffff',
      surfaceRaised: '#f8fafc',
      background: '#f1f5f9',
      border: '#e2e8f0',
      borderSubtle: '#f1f5f9',
      textPrimary: '#0f172a',
      textSecondary: '#475569',
      textDisabled: '#94a3b8',
      textInverse: '#ffffff',
      success: '#059669',
      successLight: '#ecfdf5',
      warning: '#d97706',
      warningLight: '#fffbeb',
      error: '#dc2626',
      errorLight: '#fef2f2',
      info: '#2563eb',
      infoLight: '#eff6ff',
      sidebarBg: '#0c1022',
      sidebarText: '#94a3b8',
      sidebarHover: 'rgba(255,255,255,0.06)',
    },
  },
  darkMode: {
    colors: {
      surface: '#1e293b',
      surfaceRaised: '#0f172a',
      background: '#020617',
      border: '#334155',
      textPrimary: '#f8fafc',
      textSecondary: '#94a3b8',
      sidebarBg: '#080c18',
    },
  },
}
